import React from "react"
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import Routes from "./Routes"

import {DndContext} from '@dnd-kit/core';

// import {Draggable} from './Draggable';
// import {Droppable} from './Droppable';


const App:React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes />
        <DndContext>
        </DndContext>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App